import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertasComponent } from './alertas.component';
import { MaterialModule } from '../material/material.module';
import { AlertasService } from '../../providers/alertas.service';
import { PipesModule } from '../../pipes/pipes.module';
import { MatChipsModule } from '@angular/material';

@NgModule({
  declarations: [
    AlertasComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PipesModule,
    MatChipsModule,
  ],
  exports: [
    AlertasComponent
  ],
  providers: [
    AlertasService,
  ]
})
export class AlertasModule { }
